var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{staticClass:"customflow-container",attrs:{"bordered":true,"dis-hover":""}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._t("title"),_c('p',{staticClass:"title-item"},[_vm._v(_vm._s(this.$t('common.this_month')))])],2),_c('div',{staticClass:"charts-body"},[_c('div',{attrs:{"id":"examine-approve"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }